<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-22 14:28:15
 * @LastEditors: daikeyi
 -->
<template>
    <div id="page_Container" class="login-page">
        <div class="page">
            <div id="main-container" class="main-container">

            </div>
         </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { mapActions, mapGetters } from 'vuex';
import { stringify } from 'esvcp-mobile';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';

export default {
    name: 'login',
    data() {
        return {
            mobileNumber: '', // 电话号码
            merchantCode: '', // 租户ID
            channelType: '', // 渠道类型
            channelId: '', // 渠道ID
            shortCode: '', // 子商户号
            merchantInfo: {},
            secret: ''
        };
    },
    esvReady: function() {
        document.title = '登录';
        self.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true // 禁用背景点击
        });
    },
    mounted() {
        this.loading = toastLoading();
        console.log('==========================');
        // TODO  PC端测试
        console.log('=========  navigator.userAgent  =========');
        console.log(navigator.userAgent);
        window.callbackJS = this.callbackJS;
        if (navigator.userAgent.indexOf('eslink-android') > -1 || navigator.userAgent.indexOf('Android') > -1) {
            window.android.getAccountNo({});
        } else {
            if (window.webkit) {
                window.webkit.messageHandlers.getAccountNo.postMessage({});
            }
        }
    },
    methods: {
        // ...mapActions([
        //     'esvcp/setOpId',
        //     'esvcp/setSysUserId'
        // ]),
        callbackJS(res) {
            console.log('============ callbackJS  ==============');
            console.log(res);

            clearToastLoading(this.loading);
            this.mobileNumber = res.mobileNumber;
            this.merchantCode = res.merchantCode;
            this.channelType = res.channelType;
            this.channelId = res.channelId;
            this.shortCode = res.shortCode;
            this.ESVStorage.putSessionValue(
                'shortCode',
                res.shortCode);
            this.ESVStorage.putSessionValue(
                'channelType',
                'APP');

            if (this.channelId) {
                this.handleSubmit();
            } else {
                this.gohome();
            }
        },
        getMerchantInfo() {
            const ths = this;

            ths.$doRequest({
                url: '/merchant/getMerchantInfo',
                params: {
                    channelType: this.channelType,
                    shortCode: this.shortCode
                }
            },
            function (data) {
                ths.merchantInfo = data.result;
                window.esvcp.store.commit(
                    'APP_MERCHANT_INFO',
                    data.result
                );
                ths.queryMemberAccountDetail();
            }
            );
        },
        // 点击进入登录界面
        handleSubmit() {
            const self = this;
            self.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true // 禁用背景点击
            });
            self.$doRequest({
                url: '/user/login',
                params: {
                    mobileNumber: this.mobileNumber,
                    merchantCode: this.merchantCode,
                    channelType: this.channelType,
                    channelId: this.channelId,
                    shortCode: this.shortCode
                },
                complete: function () {
                    self.$toast.clear();
                }
            },
            function (data) {
                if (data.responseCode === '100000') {
                    Toast.success('登录成功');
                    self.secret = data.result.secret;
                    self.ESVStorage.putSessionValue(
                        'secret',
                        data.result.secret);
                    self.merchantInfo = data.result;

                    self.getMerchantInfo();

                    // self.queryMemberAccountDetail();
                    const accountNo = data.result.accountNo;
                    self['esvcp/setOpId'](accountNo);
                    self['esvcp/setSysUserId'](accountNo);
                    self.ESVStorage.putSavedValue('accountNo', accountNo);
                } else {
                    Toast.fail(data.msg);
                }
            });
        },
        // 请求详情存入local
        queryMemberAccountDetail() {
            const ths = this;
            ths.$doRequest({
                url: '/account/queryMemberAccountDetail',
                params: {
                    channelType: this.channelType,
                    shortCode: this.shortCode,
                    merchantInfo: JSON.stringify(this.merchantInfo),
                    secret: this.secret
                }
            },
            (data) => {
                ths.ESVStorage.putSavedValue(
                    'accountDetail',
                    data.result);
                this.gohome();
            }
            );
        },
        gohome() {
            const ths = this;
            ths.esvReloadPage('OPHomenew');
        }
    },
    computed: {
        ...mapGetters(['merchantInfoSwitch'])
    },
    watch: {

    }
};
</script>
<style  lang="scss" scoped>

</style>
